import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=c22218e8&scoped=true&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=c22218e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22218e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c22218e8')) {
      api.createRecord('c22218e8', component.options)
    } else {
      api.reload('c22218e8', component.options)
    }
    module.hot.accept("./NotFoundComponent.vue?vue&type=template&id=c22218e8&scoped=true&", function () {
      api.rerender('c22218e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/NotFoundComponent.vue"
export default component.exports